import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chat-minimize",
  "use": "chat-minimize-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"chat-minimize\"><path fill=\"none\" stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M1.833 10.167h5v5m8.334-8.334h-5v-5m0 5L16 1M1 16l5.833-5.833\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol